@let isDesktop = device.isDesktopUI();
@let iconMode = shellStore.isIconMode();
@let isIconModeDesktop = isDesktop && (iconMode || device.isCompactDesktopUI());

<ion-split-pane contentId="shell-main" [when]="splitPaneWhen">
  <ion-menu side="start" menuId="shell-menu" contentId="shell-main" [class.icon-mode]="isIconModeDesktop">
    <ml-shell-menu [collapsed]="isIconModeDesktop" />
  </ion-menu>

  <div id="shell-main" class="ion-page bg-background flex h-full min-h-0 flex-col">
    <ml-shell-header [collapsed]="isIconModeDesktop" (menuToggle)="onMenuToggle()" />
    <div class="shell-content-area flex min-h-0 flex-1 flex-col">
      <div class="shell-content-panel flex min-h-0 flex-1 flex-col">
        <ion-router-outlet />
      </div>
    </div>
    @if (!isDesktop) {
      <ml-shell-tabs />
    }
  </div>
</ion-split-pane>
